




import { Component, Mixins } from "vue-property-decorator";
import { TextAlignKinds } from "../../domain/drawing";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class TextAlignDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  data(): any {
    return {
      options: [
        new StandardOption<TextAlignKinds>("左寄/上寄", TextAlignKinds.TopLeft),
        new StandardOption<TextAlignKinds>("中央/上寄", TextAlignKinds.TopCenter),
        new StandardOption<TextAlignKinds>("右寄/上寄", TextAlignKinds.TopRight),
        new StandardOption<TextAlignKinds>("左寄/中央", TextAlignKinds.MiddleLeft),
        new StandardOption<TextAlignKinds>("中央/中央", TextAlignKinds.MiddleCenter),
        new StandardOption<TextAlignKinds>("右寄/中央", TextAlignKinds.MiddleRight),
        new StandardOption<TextAlignKinds>("左寄/下寄", TextAlignKinds.BottomLeft),
        new StandardOption<TextAlignKinds>("中央/下寄", TextAlignKinds.BottomCenter),
        new StandardOption<TextAlignKinds>("右寄/下寄", TextAlignKinds.BottomRight),
      ],
    };
  }
}
